/* eslint-disable react-hooks/exhaustive-deps */
import { Card, TablePagination } from "@mui/material";
import moment from "moment";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AddDialog } from "../../components/component/modals/AddModal";
import { fetchProducts } from "../../redux/slices/productSlice";
import Form from "../../sections/entries/Products/Form";
import EnhancedTable from "../../sections/entries/Products/Table";
import { headCells } from "../../sections/entries/Products/headCells";

// TODO: menu options alias
const alias = {
  Status: "status",
  Brand: "brand_id",
  "Product of?": "category_id",
};

export default function Products() {
  // TODO: hooks
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  // TODO: useStates
  const [openAdd, setOpenAdd] = useState(false);
  const [pagination, setPagination] = useState({
    page: 0,
    pageSize: 20,
  });
  const [refresh, setRefresh] = useState(false);
  const [search, setSearch] = useState("");
  const [activeTab, setActiveTab] = useState("all");
  const [selectedFilters, setSelectedFilters] = useState({});

  const [rows, setRows] = useState([]);

  // TODO: get the data from slice
  const products = useSelector((state) => state.product.products);

  const formattedFilters = Object.entries(selectedFilters).reduce(
    (acc, [key, { value }]) => {
      switch (alias[key]) {
        case "category_id":
          return {
            "category.parent.id": {
              $eq: value,
            },
          };
        default:
          return (acc[alias[key]] = value);
      }
    },
    {}
  );

  // TODO: fetch the products when searached
  useEffect(() => {
    if (search) {
      const debounce = setTimeout(() => {
        dispatch(
          fetchProducts({
            enqueueSnackbar,
            filter: formattedFilters,
            search: {
              $or: [
                {
                  name: {
                    $like: search,
                  },
                  sku: {
                    $like: search,
                  },
                },
              ],
            },
            tabFilter: activeTab,
            params: {
              populate: "gallery,variations,category.parent.parent,brand",
              pageSize: pagination.pageSize,
              page: pagination.page + 1,
            },
          })
        );
      }, [2000]);
      return () => clearTimeout(debounce);
    } else {
      dispatch(
        fetchProducts({
          enqueueSnackbar,
          filter: formattedFilters,
          search,
          tabFilter: activeTab,
          params: {
            populate: "gallery,variations,category.parent.parent,brand",
            pageSize: pagination.pageSize,
            page: pagination.page + 1,
          },
        })
      );
    }
  }, [
    dispatch,
    search,
    pagination.pageSize,
    pagination.page + 1,
    activeTab,
    selectedFilters,
  ]);

  // TODO: set the rows

  useEffect(() => {
    const data = products?.data?.map((product) => ({
      id: product?.id,
      slug: product?.slug,
      name: product?.name,
      price: product?.price,
      selling_price: product?.selling_price,
      sku: product?.sku,
      status: product?.status,
      is_new: product?.is_new,
      is_trending: product?.is_trending,
      weekly_deals: product?.weekly_deals,
      is_featured: product?.is_featured,
      is_weekly_deals: product?.is_weekly_deals,
      description: product?.description,
      gallery: product?.gallery,
      category: product?.category,
      variations: product?.variations,
      brand: product?.brand,
      stock: product?.stock,
      createdDate: moment(product?.created_at)
        .format("Do MMMM, YYYY")
        .replace(/(\d+)(th|st|nd|rd)/, "$1$2"),
    }));
    setRows(data);
  }, [products]);

  // TODO: functions
  const handleChangePage = (event, newPage) => {
    setPagination((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPagination((prev) => ({
      ...prev,
      page: 0,
      pageSize: parseInt(event.target.value, 10),
    }));
  };

  // TODO: filter the data
  const handleFilter = () => {
    dispatch(
      fetchProducts({
        enqueueSnackbar,
        params: {
          populate: "gallery,variations,category.parent.parent,brand",
          pageSize: pagination.pageSize,
          page: pagination.page + 1,
        },
        filter: formattedFilters,
        search,
      })
    );
  };

  // TODO: console.logs

  return (
    <>
      <Card color="transparent" shadow={false}>
        <EnhancedTable
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          showSearch={true}
          showAdd={true}
          title="Products"
          headCells={headCells}
          rows={rows}
          showFilter={true}
          setOpenAdd={() => setOpenAdd((prev) => !prev)}
          page={pagination.page + 1}
          rowsPerPage={pagination.pageSize}
          setRefresh={setRefresh}
          refresh={refresh}
          search={search}
          setSearch={setSearch}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          handleFilter={handleFilter}
        />

        {/* TODO: pagination */}
        <TablePagination
          rowsPerPageOptions={[10, 20, 30, 40]}
          component="div"
          count={products?.meta?.total}
          rowsPerPage={pagination.pageSize}
          page={pagination.page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>

      {/* TODO: add products */}
      <AddDialog
        maxWidth="lg"
        title={"Add new product"}
        open={openAdd}
        handleClose={() => setOpenAdd(false)}
        setRefresh={setRefresh}
      >
        <Form
          handleClose={() => setOpenAdd(false)}
          refresh={refresh}
          setRefresh={setRefresh}
        />
      </AddDialog>
    </>
  );
}
